import React from 'react';

import MuiDialogActions, {
  DialogActionsProps as MuiDialogActionsProps,
} from '@mui/material/DialogActions';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const DialogActions = withCoreProps<DialogActionsProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<DialogActionsProps>) => {
    // const classes = useStyles({});
    const clsxClass = clsx(className);

    return (
      <MuiDialogActions {...props} className={clsxClass}>
        {children}
      </MuiDialogActions>
    );
  },
);

export interface DialogActionsProps extends MuiDialogActionsProps, CoreProps {}
